import React from "react";
import Kanban from "./Kanban";
import { GlobalStyle } from "./styles/kanban-styles";

const GloballyStyledKanban = (props) => (
  <>
    <GlobalStyle />
    <Kanban {...props} />
  </>
);

export default GloballyStyledKanban;
